import {
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Typography,
} from "@material-ui/core";
import React from "react";

export const EmptyPalletConfirmDialog = ({
	open,
	ssccs,
	translate,
	onConfirm,
	onReject,
	onClose,
}) => {
	if (!open) return null;

	return (
		<Dialog open={true} onClose={onClose} maxWidth="sm" fullWidth>
			<DialogTitle>
				{translate("tab.picking_list.box_movement.empty_pallet_confirmation.title")}
			</DialogTitle>
			<DialogContent>
				<Typography>
					{translate("tab.picking_list.box_movement.empty_pallet_confirmation.message")}
				</Typography>
				<Box mt={1}>
					{ssccs.map((sscc) => (
						<Typography key={sscc} variant="body2">
							<strong>{sscc}</strong>
						</Typography>
					))}
				</Box>
				<Box mt={2}>
					<Typography>
						{translate("tab.picking_list.box_movement.empty_pallet_confirmation.question")}
					</Typography>
				</Box>
			</DialogContent>
			<DialogActions>
				<Button onClick={onReject} color="secondary">
					{translate("osfc.buttons.no")}
				</Button>
				<Button onClick={onConfirm} color="primary" variant="contained">
					{translate("osfc.buttons.yes")}
				</Button>
			</DialogActions>
		</Dialog>
	);
};
